import AnimatedSection from '../common/AnimatedSection'
import { companyOverview } from '../../data/siteData'
import {
  IconCustomerCommitment,
  IconGlobalSourcing,
  IconQualityAssurance,
  IconTimelyDelivery,
} from '../icons/AboutCompanyIcons'

const aboutCompanyImage = '/assets/about-company-facility.png'

const companyFeatures = [
  {
    title: 'Global Sourcing Network',
    text: 'Strong network of trusted suppliers across the globe.',
    Icon: IconGlobalSourcing,
  },
  {
    title: 'Quality Assurance',
    text: 'Strict quality control to ensure premium-grade materials.',
    Icon: IconQualityAssurance,
  },
  {
    title: 'Timely Delivery & Logistics',
    text: 'Efficient logistics solutions for on-time delivery.',
    Icon: IconTimelyDelivery,
  },
  {
    title: 'Customer Commitment',
    text: 'Building long-term relationships with our clients.',
    Icon: IconCustomerCommitment,
  },
]

function AboutCompanySection() {
  const [paragraphOne, paragraphTwo] = companyOverview

  return (
    <AnimatedSection className="about-company-section" id="about-company">
      <div className="container corp-container">
        <div className="row g-4 g-lg-5 align-items-center about-company-main">
          <div className="col-lg-6">
            <div className="about-company-visual">
              <span className="about-company-dots" aria-hidden="true" />
              <img
                src={aboutCompanyImage}
                alt="Torbit Metals branded industrial facility with logistics truck"
                loading="lazy"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="about-company-copy">
              <span className="section-label section-label--gold">Our Company</span>
              <h2 className="about-company-title">
                Building Strong <span>Global</span> Partnerships
              </h2>
              {paragraphOne && <p className="about-company-text">{paragraphOne}</p>}
              {paragraphTwo && <p className="about-company-text">{paragraphTwo}</p>}
            </div>
          </div>
        </div>

        <div className="about-company-features" role="list">
          {companyFeatures.map(({ title, text, Icon }) => (
            <article className="about-company-feature" key={title} role="listitem">
              <span className="about-company-feature-icon">
                <Icon />
              </span>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default AboutCompanySection
